import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { effectMessages } from '../messages/effectMessages';
import { timelineMessages } from '../messages/timelineMessages';
import styles from './TimelineHeads.module.scss';

/** The names of the lanes (design Timeline): Time, Sections, Footage, Text, Effects, Lyrics, Song (locked). */
const TimelineHeadsComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.heads}>
      <div className={clsx(styles.hRuler, styles.headSmall)}>{intl.formatMessage(timelineMessages.laneTime)}</div>
      <div className={clsx(styles.hSections, styles.headSmall)}>
        {intl.formatMessage(timelineMessages.laneSections)}
      </div>
      <div className={styles.hFootage}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <rect x="3" y="6" width="13" height="12" rx="2" />
          <path d="M16 10l5-3v10l-5-3" />
        </svg>
        {intl.formatMessage(timelineMessages.laneFootage)}
      </div>
      <div className={styles.hText}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M5 6h14" />
          <path d="M12 6v13" />
        </svg>
        {intl.formatMessage(timelineMessages.laneText)}
      </div>
      <div className={styles.hEffects}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z" />
          <path d="M18 15l.8 2.2 2.2.8-2.2.8L18 21l-.8-2.2-2.2-.8 2.2-.8z" />
        </svg>
        {intl.formatMessage(effectMessages.lane)}
      </div>
      <div className={styles.hLyrics}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M4 7h16" />
          <path d="M4 12h10" />
          <path d="M4 17h13" />
        </svg>
        {intl.formatMessage(timelineMessages.laneLyrics)}
      </div>
      <div className={styles.hSong}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M9 18V6l10-2v12" />
          <circle cx="6.5" cy="18" r="2.5" />
          <circle cx="16.5" cy="16" r="2.5" />
        </svg>
        {intl.formatMessage(timelineMessages.laneSong)}
        <span className={styles.headLock} title={intl.formatMessage(timelineMessages.songLocked)}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
            width="12"
            height="12"
            aria-hidden
          >
            <rect x="5" y="11" width="14" height="9" rx="2" />
            <path d="M8 11V8a4 4 0 0 1 8 0v3" />
          </svg>
        </span>
      </div>
    </div>
  );
};

export const TimelineHeads = TypedMemo(TimelineHeadsComponent);
